import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import FormControlInput from "src/components/shared/FormControlInput";

export default function OrderReturnRefundTable({ prod, setProdPick, prodPick }) {
  const [list, setList] = useState([]);

  useEffect(() => {
    if (prod?.orderDetails) {
      const index = prod?.orderDetails?.findIndex((v) => v?._id === prodPick?._id);
      if (index !== -1) {
        const temp = [...prod?.orderDetails];
        temp[index] = { ...temp[index], returnQty: prodPick?.returnQty };
        setList(temp);
      } else {
        setList(prod?.orderDetails);
      }
    }
  }, [prod?.orderDetails, prodPick, prodPick?.returnQty]);

  return (
    <TableContainer>
      <Table
        component={Paper}
        elevation={0}
        sx={{
          minWidth: 650,
          borderRadius: "12px",
          border: "1px solid var(--grey)",
        }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              sx={{ fontWeight: "bold" }}
            >
              STT
            </TableCell>
            <TableCell
              align="center"
              sx={{ fontWeight: "bold" }}
            >
              Sản phẩm
            </TableCell>
            <TableCell
              align="center"
              sx={{ fontWeight: "bold" }}
            >
              Số lượng
            </TableCell>
            <TableCell
              align="center"
              sx={{ fontWeight: "bold" }}
            >
              SL trả
            </TableCell>
            <TableCell
              align="center"
              sx={{ fontWeight: "bold" }}
            ></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list?.map((v, i) => {
            return (
              <Item
                key={i}
                item={v}
                index={i}
                setProdPick={setProdPick}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const Item = ({ item, index }) => {
  const { setValue } = useFormContext();
  const handleChangeQty = (e) => {
    setValue(`prod.${index}.pickedQty`, +e.target.value);
  };

  return (
    <TableRow sx={{ "& td": { verticalAlign: "middle", height: "50px" } }}>
      <TableCell align="center">{index + 1}</TableCell>
      <TableCell align="center">{item?.productModel?.product?.name ?? "-"}</TableCell>
      <TableCell align="center">{item?.qty ?? 0}</TableCell>
      <TableCell align="center">
        <FormControlInput
          name={`prod.${index}.pickedQty`}
          placeholder="Số lượng"
          required
          type="number"
          size="small"
          onChange={handleChangeQty}
          hiddenHelperText
          sx={{
            width: "100%",
            maxWidth: "100px",
            mx: "auto",
            position: "relative",
          }}
        />
      </TableCell>
    </TableRow>
  );
};
